import { createFileRoute } from "@tanstack/react-router";

import Users from "~/pages/Administration/Users";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/administration/users")({
  staticData: ROUTE_STATIC.administration,
  component: Users,
});
